const wrapDivs = (divs: NodeListOf<Element>, targetDivClass: Array<string>) => {
  const divArray = Array.from(divs);
  for (let i = 0; i < divArray.length; i += divArray.length) {
    const wrapper = document.createElement("div");
    targetDivClass.forEach((e) => {
      wrapper.classList.add(e);
    });
    const elements = divArray.slice(i, i + divArray.length);
    elements[0].parentNode.insertBefore(wrapper, elements[0]);
    for (let j = 0; j < elements.length; j++) {
      wrapper.appendChild(elements[j]);
    }
  }
};

export default wrapDivs;
